// extracted by mini-css-extract-plugin
export default {"container":"container-pRGL_","content":"content-BJMNX","orangeText":"orangeText-p3YUp","navigateButton":"navigateButton-VKSxs","link":"link-zqpfl"};